import DomainCommon from './common';

const MedicalService = {
    listApplyingMedicals: () => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchGet({
                url: `${DomainCommon.getUecareApiUrl()}/ui/adminMedical/medical/applying`,
                resolve, reject
            });
        });
    },
    // Admin medical can get the same of institution medical's personal information
    findById: (medicalId) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchGet({
                url: `${DomainCommon.getUecareApiUrl()}/ui/adminMedical/medical/${medicalId}`,
                resolve, reject
            })
        })
    },
    // Admin medical can get the same of institution medical list information
    list: () => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchGet({
                url: `${DomainCommon.getUecareApiUrl()}/ui/adminMedical/medical/list`,
                resolve, reject
            })
        })
    },
    // Admin medical can change the same of institution medical's personal information
    updateMedical: ({medical, medical: {id}}) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchPut({
                url: `${DomainCommon.getUecareApiUrl()}/ui/adminMedical/medical/${id}`,
                jsonBody: medical,
                resolve, reject
            })
        })
    },
    validateMedical: (medicalId) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchPut({
                url: `${DomainCommon.getUecareApiUrl()}/ui/adminMedical/medical/${medicalId}/validate`,
                resolve, reject
            });
        });
    },
    disableMedical: (medicalId) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchPut({
                url: `${DomainCommon.getUecareApiUrl()}/ui/adminMedical/medical/${medicalId}/disable`,
                resolve, reject
            });
        });
    },
    getWorkEventsByMonth: ({ id, month }) =>
        new Promise((resolve, reject) =>
            DomainCommon.fetch({
                url: `${DomainCommon.getUecareApiUrl()}/ui/adminMedical/medical/${id}/workEvents?date=${month}`,
                resolve,
                reject,
            })),
    putWorkEventsByMonth: ({ id, month, workEvents }) =>
        new Promise((resolve, reject) =>
            DomainCommon.fetchPut({
                url: `${DomainCommon.getUecareApiUrl()}/ui/adminMedical/medical/${id}/workEvents?date=${month}`,
                jsonBody: workEvents,
                resolve,
                reject,
            })),
};

export default MedicalService;



// WEBPACK FOOTER //
// ./src/service/medical.js